const links = [
  {
    title: '京东提报平台',
    href: 'http://mc.jd.com',
  },
  {
    title: '京东营销投放平台',
    href: 'http://ace.jd.com',
  },
  {
    title: '京东通天塔平台',
    href: 'https://babel.m.jd.com/active/babelCommon/index.html#/',
  },
  {
    title: '羚珑',
    href: 'http://ling.jd.com',
  },
];

export default links;
